import client from './client';

export const getFarmTableData = ({ cursor, limit, tenant, filter }) =>
  client.post(`/terrain/v2/farmreport/table/`, {
    tenant_id: tenant,
    cursor: cursor,
    limit: limit,
    filters: filter
  });

export const getBlockList = cluster =>
  client.get(`/management/v1/management/farmlands/blocks/list/${cluster}`);

export const getBlockDetails = ({ tenantId, blockId }) =>
  client.get(
    `/management/v1/management/farmland/blocks/${tenantId}/${blockId}`
  );

export const getTerrainData = ({ tenant_id, parent_id, project_ids }) =>
  client.post('/terrain/v2/farmland/', {
    tenant_id: tenant_id,
    parent_id: parent_id,
    project_ids: project_ids
  });
export const getHydrologyData = ({ tenant_id, parent_id, project_ids }) =>
  client.post('/hydrology/v2/farmland/', {
    tenant_id: tenant_id,
    parent_id: parent_id,
    project_ids: project_ids
  });
export const getEnvironmentData = ({ tenant_id, parent_id, project_ids }) =>
  client.post('/environment/v2/farmland/', {
    tenant_id: tenant_id,
    parent_id: parent_id,
    project_ids: project_ids
  });
export const getPedologyData = ({ tenant_id, parent_id, project_ids }) =>
  client.post('/pedology/v2/farmland/', {
    tenant_id: tenant_id,
    parent_id: parent_id,
    project_ids: project_ids
  });
export const getExportAllData = tenant_id =>
  client.get(`/terrain/v2/farmreport/export/table/${tenant_id}`);
